import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ReferenceDataCategoriesConstants,
  ReferenceDataConstants,
  ReferenceDataLabels,
  ReferenceDataService
} from 'rome-library';

import { PopUpService } from '../../../../../core';

@Component({
  selector: 'boi-gdpr-dialog',
  templateUrl: './gdpr-dialog.component.html'
})
export class GdprDialogComponent implements OnInit {
  @Input() public opened: boolean;
  @Output() public readonly openedChange = new EventEmitter<boolean>();

  public logoPath: string;

  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(
    private readonly referenceDataService: ReferenceDataService,
    private readonly popUpService: PopUpService
  ) {}

  public ngOnInit(): void {
    const resourcesRelativePath = this.referenceDataService.getConfigurationValue(
      ReferenceDataCategoriesConstants.UI_CUSTOMIZATION,
      ReferenceDataConstants.UICustomizationResourcesRelativePath
    );

    const gdprPolicyLogoHeader = this.referenceDataService.getLocalizeLabel(
      this.referenceDataLabels.GdprPolicyLogoHeader
    );

    this.logoPath = resourcesRelativePath + gdprPolicyLogoHeader;
  }

  public getGdprPdf(): void {
    this.popUpService.openPopUp(`/ExternalConfiguration/GetGdprPrivacyPolicyPdf`);
  }

  public close(): void {
    this.opened = false;
    this.openedChange.emit();
  }
}
